<mapfre-card [singleCard]="true" additionalClasses="policy-account-exist-container">
  <div class="policy-card">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon margin-bottom mb8">
          <figure>
            <img src="./assets/img/images/expired.svg" alt="Otp" />
          </figure>
        </div>
        <h1 class="policy-account-title">{{ "EXISTING_ACCT" | translate }}</h1>
        <p class="policy-exist-para big-para policy-acct-txt-color mb-4">
          {{
            "Our records show this policy is linked to an existing account.
          To access the policy, please log in using the email below."
              | translate
          }}
        </p>
        <P class="policy-acct-email">{{ emailMask }}</P>
        <p class="policy-exist-para policy-acct-txt-color mt-2">
          {{
            "If you don't recognize the email above or if it needs to be updated, please contact our Customer Service department."
              | translate
          }}
        </p>
        <div>
          <a
            href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}"
            class="mapfre link dm-sans-medium red-link font-size medium-font underline"
          >
            {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
          </a>
        </div>
      </div>
    </div>
    <div class="row text-center margin-top mt24 acc-exists-back-btn">
      <div class="col">
        <mapfre-button
          additionalClasses="link-button red-link small button-border-red"
          [backIcon]="'./assets/img/icons/back-arrow-red.png'"
          [iconClasses]="'align-middle'"
          (click)="goBack()"
          [showIconsCustom]="true"
        >
          {{ "BACK" | translate }}
        </mapfre-button>
      </div>
    </div>
  </div>
</mapfre-card>
